import type { CSSProperties } from 'react'
import { readStoredColumnWidths, saveColumnWidths } from '@/tableControls'

export function fixedColumnStyle(width: number): CSSProperties {
  return {
    width,
    minWidth: width,
    maxWidth: width,
    boxSizing: 'border-box',
  }
}

export function migrateLegacyColumnWidths(
  pageKey: string,
  legacyKeys: readonly string[],
  columnKeys: readonly string[]
): void {
  const existing = readStoredColumnWidths(pageKey)
  if (Object.keys(existing).length > 0) return
  for (const legacyKey of legacyKeys) {
    try {
      const raw = localStorage.getItem(legacyKey)
      if (!raw) continue
      const parsed = JSON.parse(raw) as Record<string, unknown>
      const widths: Record<string, number> = {}
      for (const key of columnKeys) {
        const value = parsed[key]
        if (typeof value === 'number' && Number.isFinite(value)) {
          widths[key] = value
        }
      }
      if (Object.keys(widths).length > 0) {
        saveColumnWidths(pageKey, widths)
      }
      return
    } catch {
      /* try next legacy key */
    }
  }
}

export function escapeCsvCell(value: string): string {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

import { downloadTextFile } from './downloadFile'

export { downloadTextFile }

export function downloadCsvFile(filename: string, csvBody: string): void {
  downloadTextFile(filename, csvBody, 'text/csv')
}
